
import { Component, OnInit,ViewChild,TemplateRef,Input, group } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import {NgbModal, ModalDismissReasons,NgbModalRef,NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

import { Router,ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { FileSelectDirective,FileUploader,FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import {Globals} from '../.././globals';
import { GroupService } from '../../service/group.service';
import { commonService } from '../../service/common.service';



@Component({
  selector: 'app-vgroup',
  templateUrl: './vgroup.component.html',
  styleUrls: ['./vgroup.component.css'],
  providers:[GroupService]
})
export class VgroupComponent implements OnInit {

  @ViewChild('group') public creategroup: TemplateRef<any>;
  modalReference:NgbModalRef;
  msg:any;
  isError=false;
  isSuccess=false;
  groupIcon ='';
  formvailidation=false;
  title:any;
  aboutGroup='';
  groupPrivacy='';
  groups:any;
  filterform:any;
  autoload:any;
  user:any;
  grouptitle:any;
  group:any;
  groupActionBox=false;
  passcode:string;
  ispasscode=false;
  progress:any=0;
  readonly rootUrl = this.global.siteUrl;
  readonly profileUrl  =  this.global.profileUrl;
  url =this.rootUrl+'file/upload?folder='+this.global.groupProfileFolder;
  path=this.global.groupProfileUrl;
  @Input() fileExt: string = "";
  errors: Array<string> =[];
  fileExtExists=false;
  uploader:FileUploader=new FileUploader({url:this.url,authToken:sessionStorage.getItem('_to'),maxFileSize: 20000000 ,allowedMimeType: ['image/png','image/jpeg','image/jpg']});
  attactmentlist:number;


  constructor(private _common:commonService,private modalService: NgbModal,private global:Globals,private _group:GroupService,private router:Router) { 

    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
    this.uploader.clearQueue = ()=>this.clearQueue();
    this.uploader.onWhenAddingFileFailed = (fileItem) => {
      this.msg="File size must 20mb or below.";
      this.isError = true;
      this.isSuccess = false;
    }

  }

  ngOnInit() {
    // get user details
  this._common.profile.subscribe((data:any)=>{
    this.user = data;
    
    })
    this.getUserGroup();
  }

  getUserGroup(){

    let userType = 'ad'
    this._group.getUserGroup({type:userType}).subscribe((data : any)=>{
      if(data.error==0){ 
       this.groups=  data.results;
         console.log(this.groups);
      }else{
        if(data.message=="Failed to authenticate token."){
          this.router.navigate(['/']);
        }else{
        this.msg = data.message;
        this.isError = true;
        this.isSuccess = false;
        }
      }
  },
      (error : HttpErrorResponse)=>{
        this.isError = true;
        this.msg="internal server error!";
      });
  
  } 
  
  openGroupForm(content){
    console.log('1111111111');
    //let localmodalReference=this.modalReference;
    this.grouptitle="Create";
    this.groupIcon =this.path+'/grouplogo.svg';
    this.clearQueue()
    // form filed blank
    this.group='';
    this.title='';
    this.aboutGroup='';
    this.groupPrivacy='';
   // if(content != null){
      this.modalReference =  this.modalService.open(content,{size: 'lg',backdrop : 'static',
      keyboard : false }); 
    //}
  }

  onFileChanged($event){
     this.uploader.uploadAll();
     this.progress=1;
   }

   /****file uploder responce***/
onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
  let data = JSON.parse(response); //success server response
//console.log(data);

    if(data.error==0){
      this.progress=0;
      this.groupIcon  = this.path+'/grouplogo.svg';
     this.attactmentlist=data.result.id;
    }


 
   
}

onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    let error = JSON.parse(response); //error server response
    
}  


ngAfterViewInit() {
  this.uploader.onAfterAddingFile = (item => {
     item.withCredentials = false;
  });
 }

 clearQueue() {
  this.uploader.queue = [];
  this.attactmentlist=0;
  
  
 }
/****file uploder responce***/

addGroup(formData){
  if(formData.status=="INVALID"){
    this.formvailidation=true;
   }else{
    this.formvailidation=false;
    formData.value['logo']  =  this.attactmentlist;
    formData.value['passCode'] =this.passcode;
    this._group.addGroup(formData.value).subscribe((data : any)=>{
    if(data.error==0){ 
      this.modalReference.close();
      this.router.navigate(['/admin/discussion/group/'+encodeURIComponent(btoa(data.group))])
    }else{
      if(data.message=="Failed to authenticate token."){
        this.router.navigate(['/']);
      }else{
      this.msg = data.message;
      this.isError = true;
      this.isSuccess = false;
      }
    }
},
    (error : HttpErrorResponse)=>{
      this.isError = true;
      this.msg="internal server error!";
    });

} 

}

groupsdetails(id){
  this.router.navigateByUrl('/admin/discussion/group/'+encodeURIComponent(btoa(id)));
}

delcontent(event,index){

if(confirm('Do you want to delete?')){
  this._group.delgroup({"group":encodeURIComponent(btoa(event.id))}).subscribe((data:any)=>{
    if(data.error==0){ 
        this.groups.splice(index, 1);
    }else{
      if(data.message=="Failed to authenticate token."){
        this.router.navigate(['/']);
      }else{
      //this.msg = data.message;
     // this.isError = true;
     // this.isSuccess = false;
      }
    }
},
    (error : HttpErrorResponse)=>{
    //  this.isError = true;
      //this.msg="internal server error!";
    });
}

}

editcontent(obj,index,content){

  
  this.grouptitle="Update";
  this.groupActionBox = false;
 
  if(obj.logo==""){
  this.groupIcon =this.path+'/grouplogo.svg';
  }else{
    this.groupIcon= this.path+obj.logo;
  }
  this.clearQueue()
  this.group=encodeURIComponent(btoa(obj.id));
  this.title=obj.title;
  this.aboutGroup=obj.aboutGroup;
  this.groupPrivacy=obj.groupPrivacy;
  if(obj.groupAction=="Request"){
     this.groupActionBox = true;
  }
  if(this.groupPrivacy=='Private'){
    this.ispasscode=true;
    //this.passcode=obj.passCode;
  }else{
  this.ispasscode=false;

  }
  this.modalReference =  this.modalService.open(content,{size: 'lg',backdrop : 'static',
    keyboard : false }); 
    this.grouptitle="Update";
}

genratepasscode(){
  this.passcode = Math.random().toString(36).substring(2,8).toUpperCase();
}
getgroupPrivacy(event){

  if(event=='Private'){
    this.ispasscode=true;
  }else{
    this.ispasscode=false;
    this.passcode='';

  }
}

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/discussion/vgroup/vgroup.component.ts